import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ESurveyTypes } from '@prohabits/metaverse'

import { getIdentityFirstLoginFlow, getOnboardingSurveyData, getIdentityStage } from 'store/entities/identity/selectors'
import { requestSurvey, updateOnboardingChecklist } from 'store/entities/identity/actions'
import OnboardingBriefQuiz from 'app/domains/routes/OnBoarding/OnBoardingBriefQuiz/OnBoardingBriefQuiz'
import { showTypeFormPopup } from 'store/entities/typeform/actions'
import { modal } from 'store/entities/modal/actions'
import { SELECTION, DONE } from 'app/constants/stages'
import { IDispatchProps, IOwnProps, IStateProps } from './interface'
import { IS_QUIZ_COMPLETED } from 'app/constants/onBoarding'

const mapStateToProps = createStructuredSelector({
  isLoginFlowFinished: getIdentityFirstLoginFlow,
  surveyData: getOnboardingSurveyData,
  getIdentityStage,
})

const mapDispatchToProps = {
  requestSurvey: ({ isPostSurvey, sendEmail }: any) =>
    requestSurvey({
      surveyType: isPostSurvey ? ESurveyTypes.end : ESurveyTypes.begin,
      sendEmail,
    }),
  showTypeFormPopup,
  hideModal: modal.hide,
  updateOnboardingChecklist,
}

const mergeProps = (
  { surveyData, getIdentityStage, ...restState }: IStateProps,
  { showTypeFormPopup, requestSurvey, hideModal, updateOnboardingChecklist, ...restDispatch }: IDispatchProps,
  ownProps: IOwnProps
) => {
  const isPostSurvey = getIdentityStage === SELECTION || getIdentityStage === DONE

  return {
    ...restState,
    ...ownProps,
    ...restDispatch,
    requestSurvey,
    hideModal,
    isPostSurvey,
    surveyData,
    showTypeFormPopup: () => {
      showTypeFormPopup({
        typeFormData: surveyData,
        onSubmit: () => {
          requestSurvey({ isPostSurvey, sendEmail: false })
          updateOnboardingChecklist({ propertyName: IS_QUIZ_COMPLETED, propertyValue: true })
          hideModal()
        },
      })
    },
  }
}
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(OnboardingBriefQuiz)
